<div class="container-fluid hero-alt">
  <div class="container h-100">
    <div class="d-flex flex-column justify-content-end justify-content-md-center h-100 pb-4 pb-md-0">
      <div class="text-slot">
        <ng-content select="[slot=slotText]"></ng-content>
      </div>
      <ng-content select="[slot=slotSearchBar]"></ng-content>
    </div>
  </div>
</div>
